/* eslint-disable array-callback-return*/

import React, { useState, useEffect } from "react";
import { STYLE_DEFAULT_TAB_BED } from "App/constants/theme";

import clsx from "clsx";
import {
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  makeStyles,
  Toolbar,
  Typography,
} from "@material-ui/core";
import {
  DatatablesFooter,
  IconButtonDatatable,
  SearchInput,
  TableToolbar,
  MasterButton,
  ModalDefaultError,
  ModalDeleteConfirm,
  TableCellDefault,
  TableHeader,
} from "App/Component/ui";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables, useFetch } from "App/hooks";
import {
  deleteGolonganKelasById,
  getListBed,
  headCells,
  ModalForm,
  RESET_STATE_GOLONGAN_KELAS,
  STATE_FILTER_BED,
} from "./helpers";
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  fetchDataPost,
  isNull,
} from "App/utils/helpers";
import {
  instance1,
  instance2,
  instanceApplicares,
  TYPE_INSTANCE2,
  TYPE_INSTANCEAPPLICARES,
} from "App/constants";
import { LIST_URL_MASTER } from "utils/masters";
import ModalRuangAplicares from "./ModalRuangAplicares";
import ModalKetersediaanAplicare from "./ModalKetersediaanAplicare";
import useOpenDialog from "pages/Dashboard/SettingDashboard/hooks/useOpenDialog";
import DialogBedApplicares from "pages/Dashboard/SettingDashboard/DialogBedApplicares";

const useStyles = STYLE_DEFAULT_TAB_BED;

export default function TabGolonganKelas() {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);
  const [showModalRuangAplicare, setShowModalRuangAplicare] = useState(false);
  const [showModalKetersediaanAplicare, setShowModalKetersediaanAplicare] =
  useState(false);
  const [showModalDefaultError, setShowModalDefaultError] = useState(false);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState(RESET_STATE_GOLONGAN_KELAS);
  const [rowsRuangAplicare, setRowsRuangAplicare] = useState([]);
  const [stateUpdate, setStateUpdate] = useState(false);
  const [openBedApp, setOpenBedApp] = useState(false);
  
  const ruangAplicare = useFetch(
    TYPE_INSTANCE2,
    LIST_URL_MASTER.ruang_aplicares.list
  );

  useEffect(() => {
    setNewData();
  }, []);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  async function setNewData() {
    const res = await fetchData(
      TYPE_INSTANCE2,
      LIST_URL_MASTER.golkelas_aplicares.list
    );
    setRows(res);
  }

  async function deleteList() {
    const res = await deleteGolonganKelasById(formData.id);

    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewData();
    } else {
      defaultToastError(res.message);
    }
    setShowModalDeleteConfirm(false);
  }

  const handleClickAddRuangAplicare = async (row) => {
    const check = rowsRuangAplicare.filter((e) => e.kode === row.kode);
    if (check.length > 0) {
      defaultToastError("Data sudah ada");
    } else {
      const rowsAplicare = rowsRuangAplicare;
      const newRowsAplicare = [row, ...rowsAplicare];
      const _temp = [];
      newRowsAplicare.map((item) => _temp.push(item.kode));
      await postToServer(_temp, newRowsAplicare, row.kode, "buat");
      await setNewData();
    }
  };

  const handleClickDeleteRuangAplicare = async (row) => {
    const newRowsAplicare = rowsRuangAplicare.filter(
      (e) => e.kode !== row.kode
    );
    const _temp = [];
    newRowsAplicare.map((item) => _temp.push(item.kode));
    await postToServer(_temp, newRowsAplicare, row.kode, "hapus");
    await setNewData();
  };

  const useToolbarStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
      display: "flex",
      justifyContent: "space-between",
    },
    title: {
      fontSize: "14px",
      textTransform: "uppercase",
      fontWeight: "600",
    },
    wrapper: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginRight: "5px",
    },
  }));

  const postToServer = async (
    kodeRuangAplicares,
    newRowsAplicare,
    kode,
    action = ""
  ) => {
    await instance2
      .post(
        LIST_URL_MASTER.golkelas_aplicares.update,
        {
          name: formData.name,
          kodebridging: formData.kodebridging,
          remark: formData.remark,
          kode_ruang_aplicares: kodeRuangAplicares.toString(),
          kode_ruang: kode,
          status_aplicares: stateUpdate ? action : "",
        },
        {
          headers: {
            idgolongankelasaplicares: formData.id,
          },
        }
      )
      .then(() => {
        defaultToastSuccess("Success");
        setRowsRuangAplicare(newRowsAplicare);
      })
      .catch((error) => {
        defaultToastError("Error");
      });
  };

  const handleClickSelect = async (row) => {
    setFormData({
      id: row?.id,
      name: row?.name,
      remark: row?.remark,
      kodebridging: row?.kodebridging,
    });
    setStateUpdate(false);
    const arr = convertToValidListAplicare(row.kode_ruang_aplicares);
    setShowModalRuangAplicare(!showModalRuangAplicare);
    setRowsRuangAplicare(arr);
  };

  const convertToValidListAplicare = (kodeRuangAplicare) => {
    const _temp = [];
    if (!isNull(kodeRuangAplicare)) {
      ruangAplicare[0].map((item) => {
        const check = kodeRuangAplicare
          .split(",")
          .filter((e) => e === item.kode);
        if (check.length > 0) {
          _temp.push(item);
        }
      });
    }
    return _temp;
  };

  const handleClickKetersediaanAplicare = (row) => {
    setShowModalKetersediaanAplicare(!showModalKetersediaanAplicare);
    setFormData({
      id: row?.id,
      name: row?.name,
      remark: row?.remark,
      kodebridging: row?.kodebridging,
    });
  };

  const classToolbar = useToolbarStyles();

  // const setNewDataBed = async () => {
  //   try {
  //     const res = await instanceApplicares.post(
  //       "/api/v1/rsannisa/aplicares/read/ketersediaan-kamar-rs",
  //       {
  //         kode_ppk: process.env.REACT_APP_KODE_PPK_RUJUKAN,
  //         start: "1",
  //         limit: "10",
  //       }
  //     );
  //     if (res.status === 200) {
  //       console.log(res?.data?.response?.list?.list);
  //       setRowsBed(res?.data?.response?.list?.list);
  //       setTotalData(res?.data?.metaData?.totalItems);
  //     }
  //   } catch (error) {
  //     return defaultToastError(error?.response?.data?.message);
  //   }
  // };

  const handleOpenBedApplicares = () => {
    setOpenBedApp(true);
    // setNewDataBed();
  };

  return (
    <>
      {openBedApp && (
        <DialogBedApplicares setShowModal={() => setOpenBedApp(false)} />
      )}
      {showModalRuangAplicare && (
        <ModalRuangAplicares
          setShowModal={() => setShowModalRuangAplicare(false)}
          handleClickAddRuangAplicare={handleClickAddRuangAplicare}
          rowsRuangAplicare={rowsRuangAplicare}
          rows={ruangAplicare[0]}
          handleClickDeleteRuangAplicare={handleClickDeleteRuangAplicare}
          stateUpdate={stateUpdate}
          setStateUpdate={setStateUpdate}
        />
      )}

      {showModalKetersediaanAplicare && (
        <ModalKetersediaanAplicare
          setShowModal={() => setShowModalKetersediaanAplicare(false)}
          id={formData.id}
        />
      )}

      <div className={classes.root}>
        {showModal && (
          <ModalForm
            setNewData={setNewData}
            setShowModal={() => setShowModal(false)}
            formData={formData}
            setFormData={setFormData}
          />
        )}

        {showModalDefaultError && (
          <ModalDefaultError
            setShowModalDefaultError={() => setShowModalDefaultError(true)}
          />
        )}

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList(formData.id)}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper>
          {/* <TableToolbar title={"Daftar Golongan Kelas Aplicares"}>
            <SearchInput
              withIcon={true}
              onchange={(e) => setQ(e.target.value)}
            />
            <MasterButton
              type={"submit"}
              color="green"
              name="Tambah"
              size="md"
              onClick={() => {
                setFormData(RESET_STATE_GOLONGAN_KELAS);
                setShowModal(!showModal);
              }}
            />
          </TableToolbar> */}
          <Toolbar className={clsx(classToolbar.root)}>
            <div className={classToolbar.wrapper}>
              <Typography
                className={classToolbar.title}
                variant="h6"
                id="tableTitle"
                component="div"
              >
                Daftar Golongan Kelas Applicares
              </Typography>
              <MasterButton
                name="Bed Applicares"
                color="indigo"
                onClick={() => handleOpenBedApplicares()}
              />
            </div>
            <div className={classToolbar.wrapper}>
              <SearchInput
                withIcon={true}
                onchange={(e) => setQ(e.target.value)}
              />
              <MasterButton
                type={"submit"}
                color="green"
                name="Tambah"
                size="md"
                onClick={() => {
                  setFormData(RESET_STATE_GOLONGAN_KELAS);
                  setShowModal(!showModal);
                }}
              />
            </div>
          </Toolbar>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"medium"}
              aria-label="enhanced table"
            >
              <TableHeader
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={length}
                headCells={headCells}
              />
              <TableBody>
                {stableSort(data, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "transparent" : "#fff",
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          padding="none"
                          align="center"
                        >
                          {index + 1}
                        </TableCell>

                        <TableCell
                          component="th"
                          scope="row"
                          padding="none"
                          align="center"
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "7px",
                            }}
                          >
                            <IconButtonDatatable
                              onClick={() => handleClickSelect(row)}
                            >
                              <SelectIcon
                                width={"16"}
                                height={"16"}
                                fill={"#fff"}
                              />
                            </IconButtonDatatable>

                            <IconButtonDatatable
                              onClick={() => {
                                setFormData({
                                  id: row?.id,
                                  name: row?.name,
                                  remark: row?.remark,
                                  kodebridging: row?.kodebridging,
                                });

                                setShowModal(true);
                              }}
                            >
                              <PencilIcon />
                            </IconButtonDatatable>

                            <IconButtonDatatable
                              onClick={() => {
                                setFormData({
                                  ...formData,
                                  id: row?.id,
                                });
                                setShowModalDeleteConfirm(
                                  !showModalDeleteConfirm
                                );
                              }}
                            >
                              <TrashIcon />
                            </IconButtonDatatable>
                          </div>
                        </TableCell>
                        <TableCell align="left">{row?.id}</TableCell>

                        <TableCell align="left">{row?.kodebridging}</TableCell>
                        <TableCell align="left">{row?.name}</TableCell>
                        <TableCell align="left">
                          <MasterButton
                            type="button"
                            color="warning"
                            name="UPDATE APLICARE"
                            onClick={() => handleClickKetersediaanAplicare(row)}
                          />
                        </TableCell>

                        <TableCell align="left">{row?.remark}</TableCell>
                        <TableCellDefault row={row} />
                      </TableRow>
                    );
                  })}
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell align="center" colSpan={headCells.length}>
                      Tidak ada data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <DatatablesFooter
            page={page}
            length={data.length}
            rowsPerPage={rowsPerPage}
            selectRows={[10, 20]}
            onPageChange={(page) => setPage(page - 1)}
            onSelectChange={(e) => setRowsPerPage(e.target.value)}
          />
        </Paper>
      </div>
    </>
  );
}
